export default [
  { name: 'toode2', description: 'Monthly subscription 0.10€' },
  { name: 'SI_DIMOCO', description: 'One minute subscription for DIMOCO telcos 39.99€' }
]
